import { Spinner, Stack } from "@chakra-ui/react";

export function Loading() {
  return (
    <Stack gap={3} alignItems={"center"}>
      <Spinner size={"xl"} animationDuration={"0.7s"} color="gray.400" />
    </Stack>
  );
}
